module.exports = __webpack_public_path__ + "static/media/icon-speak.33f29a85.svg";